/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Fullnameplaceholder2Inputs */

const he_contact_form_fullnameplaceholder2 = /** @type {(inputs: Contact_Form_Fullnameplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הכנס את שמך המלא`)
};

const en_contact_form_fullnameplaceholder2 = /** @type {(inputs: Contact_Form_Fullnameplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your full name`)
};

/**
* | output |
* | --- |
* | "Enter your full name" |
*
* @param {Contact_Form_Fullnameplaceholder2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_form_fullnameplaceholder2 = /** @type {((inputs?: Contact_Form_Fullnameplaceholder2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Fullnameplaceholder2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_form_fullnameplaceholder2(inputs)
	return en_contact_form_fullnameplaceholder2(inputs)
});
export { contact_form_fullnameplaceholder2 as "contact_form_fullNamePlaceholder" }